import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { FinancialAccountTransactionTypes } from '@webapp/models/enums'
import { type FinancialAccountTransaction } from '@webapp/models/FinancialAccountTransaction'

export const FinancialAccountTransactionMock =
  Factory.Sync.makeFactory<FinancialAccountTransaction>({
    id: Factory.each(() => faker.random.number()),
    amount: Factory.each(() => faker.commerce.price()),
    currency: CurrencyNames.USD,
    created_at: Factory.each(() => faker.date.past().toISOString()),
    posted_at: Factory.each(() => faker.date.past().toISOString()),
    vendor_name: Factory.each(() => faker.company.companyName()),
    deposit_source_name: Factory.each(() => faker.finance.accountName()),
    type: FinancialAccountTransactionTypes.PAYOUT,
    payment_id: Factory.each(() => faker.random.number()),
    card: null,
    vendor_currency: null,
    vendor_currency_amount: null,
  })
    .withDerivation1(['type'], 'deposit_source_name', (type) => {
      switch (type) {
        case FinancialAccountTransactionTypes.PAYOUT:
        case FinancialAccountTransactionTypes.FEE:
        case FinancialAccountTransactionTypes.PAYOUT_REFUND:
          return null
        case FinancialAccountTransactionTypes.DEPOSIT:
          return faker.finance.accountName()
      }
    })
    .withDerivation1(['type'], 'vendor_name', (type) => {
      switch (type) {
        case FinancialAccountTransactionTypes.PAYOUT:
        case FinancialAccountTransactionTypes.FEE:
        case FinancialAccountTransactionTypes.PAYOUT_REFUND:
        case FinancialAccountTransactionTypes.CARD_CAPTURE:
        case FinancialAccountTransactionTypes.CARD_REFUND:
          return faker.company.companyName()
        case FinancialAccountTransactionTypes.DEPOSIT:
          return null
      }
    })
    .withDerivation1(['type'], 'card', (type) => {
      switch (type) {
        case FinancialAccountTransactionTypes.CARD_CAPTURE:
        case FinancialAccountTransactionTypes.CARD_REFUND:
          return {
            cardholder_name: faker.name.findName(),
            last4: faker.finance.account(4),
          }
        default:
          return null
      }
    })
    .withDerivation1(['type'], 'payment_id', (type) => {
      switch (type) {
        case FinancialAccountTransactionTypes.CARD_CAPTURE:
        case FinancialAccountTransactionTypes.CARD_REFUND:
        case FinancialAccountTransactionTypes.DEPOSIT:
          return null
        default:
          return faker.random.number()
      }
    })
    .withDerivation1(['type'], 'payment_uuid', (type) => {
      switch (type) {
        case FinancialAccountTransactionTypes.PAYOUT:
        case FinancialAccountTransactionTypes.FEE:
        case FinancialAccountTransactionTypes.PAYOUT_REFUND:
          return null
        default:
          return faker.random.uuid()
      }
    })
